import React, { useRef, lazy } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { t } from '../utils/translations';
export function Gallery() {
  const {
    lang
  } = useLanguage();
  const text = t[lang].gallery;
  const containerRef = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start end', 'end start']
  });
  // Subtle parallax effects for images
  const y1 = useTransform(scrollYProgress, [0, 1], [50, -50]);
  const y2 = useTransform(scrollYProgress, [0, 1], [-50, 50]);
  const images = [{
    src: 'https://cdn.magicpatterns.com/uploads/tLdDH2Co6KbkemKHNLdjCK/hf_20260422_174820_270eb1e1-1802-4bfc-93e6-eb810c1d4546.png',
    label: 'Commercial Extractions'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ponTzFNsoTofRjEgbVTraM/hf_20260430_165935_f456fec4-6f67-4343-bc32-1ee8fbcb30b8.png',
    label: 'Heavy Lifting'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/gFtvrJZYGuYHQpYL1PQkRn/hf_20260422_174400_edc25ebf-f2d5-4478-b937-d3e1d4bc7689.png',
    label: 'Careful Packing'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/kiRPZ67DCoPow89rjDSeY7/hf_20260430_172717_e667c99f-785e-4196-a80e-61f75430d1ed.png',
    label: 'Happy Families'
  }];
  return <section id="gallery" className="py-24 bg-white overflow-hidden" ref={containerRef} data-id="element-277">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-278">
        <div className="text-center mb-20" data-id="element-279">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 100,
          damping: 15
        }} className="text-4xl md:text-6xl font-condensed font-black text-mf-black uppercase tracking-tight mb-6" data-id="element-280">
            {text.title}
          </motion.h2>
          <motion.div initial={{
          width: 0
        }} whileInView={{
          width: 96
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="h-1.5 bg-mf-yellow mx-auto rounded-full" data-id="element-281"></motion.div>
        </div>

        {/* Modern Asymmetric Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 h-auto md:h-[600px]" data-id="element-282">
          {/* Large Image - Left */}
          <motion.div style={{
          y: y1
        }} className="md:col-span-7 relative overflow-hidden rounded-3xl shadow-xl group h-64 md:h-full" data-id="element-283">
            <img src={images[0].src} alt={images[0].label} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-284" />
            {/* Glassmorphism Caption */}
            <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" data-id="element-285">
              <div className="bg-white/20 backdrop-blur-md border border-white/30 rounded-2xl p-4 shadow-lg" data-id="element-286">
                <span className="text-white font-condensed font-bold text-xl uppercase tracking-wider drop-shadow-md" data-id="element-287">
                  {images[0].label}
                </span>
              </div>
            </div>
          </motion.div>

          <div className="md:col-span-5 flex flex-col gap-6 h-full" data-id="element-288">
            {/* Top Right Image */}
            <motion.div style={{
            y: y2
          }} className="relative overflow-hidden rounded-3xl shadow-xl group h-64 md:h-1/2" data-id="element-289">
              <img src={images[1].src} alt={images[1].label} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-290" />
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" data-id="element-291">
                <div className="bg-white/20 backdrop-blur-md border border-white/30 rounded-xl p-3 shadow-lg" data-id="element-292">
                  <span className="text-white font-condensed font-bold text-lg uppercase tracking-wider drop-shadow-md" data-id="element-293">
                    {images[1].label}
                  </span>
                </div>
              </div>
            </motion.div>

            {/* Bottom Right Image */}
            <motion.div style={{
            y: y1
          }} className="relative overflow-hidden rounded-3xl shadow-xl group h-64 md:h-1/2" data-id="element-294">
              <img src={images[2].src} alt={images[2].label} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-295" />
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" data-id="element-296">
                <div className="bg-white/20 backdrop-blur-md border border-white/30 rounded-xl p-3 shadow-lg" data-id="element-297">
                  <span className="text-white font-condensed font-bold text-lg uppercase tracking-wider drop-shadow-md" data-id="element-298">
                    {images[2].label}
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}